import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  //Initial Loading State
  $isInitialLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  $isInitialError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


  //Prompts Loading State
  $isPromptsLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isPromptsError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isPromptsSiteLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isPromptsSiteError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


  //Chat Loading State
  $isChatLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isChatError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


  //Overview API Loading States
  $isSystemDetailsLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isSystemDetailsError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isSystemDetailsEmpty: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  $isSystemHealthLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isSystemHealthError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isSystemHealthEmpty: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  $isServiceHistoryLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isServiceHistoryError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isServiceHistoryEmpty: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  $isServiceMetricsLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isServiceMetricsError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isServiceMetricsEmpty: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  $isSiteLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isSiteError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isSiteEmpty: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


  //Overview API Loading States Sites

  $isSiteLoadingSite: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isSiteErrorSite: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isSiteEmptySite: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  $isServiceHistoryLoadingSite: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isServiceHistoryErrorSite: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isServiceHistoryEmptySite: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  $isServiceMetricsLoadingSite: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isServiceMetricsErrorSite: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isServiceMetricsEmptySite: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


  $isUpcomingServicesLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isUpcomingServicesError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isUpcomingServicesEmpty: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  $isUpcomingServiceDetailsLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isUpcomingServiceDetailsError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isUpcomingServiceDetailsEmpty: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  //Detail API Loading States
  $isAutocheckLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isAutocheckError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isAutocheckEmpty: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  $isErrorsLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isErrorsError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isErrorsEmpty: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  $isSubbyLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isSubbyError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isSubbyEmpty: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  $isMaintenanceLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isMaintenanceError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isMaintenanceEmpty: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  $isPSMLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isPSMError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isPSMEmpty: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  $isPSMDetailsLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isPSMDetailsError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  $isNotificationsLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isNotificationsError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isNotificationsEmpty: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  $isNotificationDetailsLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isNotificationDetailsError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  $isNotificationSummaryLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isNotificationSummaryError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  $isSparePartsLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isSparePartsError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isSparePartsEmpty: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  $isVisitsLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isVisitsError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isVisitsEmpty: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  $isEscalationsLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isEscalationsError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $isEscalationsEmpty: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() { }

  resetAllStates() {
    //Initial Loading State
    this.$isInitialLoading.next(false);
    this.$isInitialError.next(false);

    //Prompts Loading State
    this.$isPromptsLoading.next(false);
    this.$isPromptsError.next(false);
    this.$isPromptsSiteLoading.next(false);
    this.$isPromptsSiteError.next(false);
    //Chat Loading State
    this.$isChatLoading.next(false);
    this.$isChatError.next(false);

    //Overview API Loading States
    this.$isSystemDetailsLoading.next(false);
    this.$isSystemDetailsError.next(false);
    this.$isSystemDetailsEmpty.next(false);

    this.$isSystemHealthLoading.next(false);
    this.$isSystemHealthError.next(false);
    this.$isSystemHealthEmpty.next(false);

    this.$isServiceHistoryLoading.next(false);
    this.$isServiceHistoryError.next(false);
    this.$isServiceHistoryEmpty.next(false);

    this.$isServiceMetricsLoading.next(false);
    this.$isServiceMetricsError.next(false);
    this.$isServiceMetricsEmpty.next(false);

    this.$isSiteLoading.next(false);
    this.$isSiteError.next(false);
    this.$isSiteEmpty.next(false);

    //Detail API Loading States
    this.$isAutocheckLoading.next(false);
    this.$isAutocheckError.next(false);
    this.$isAutocheckEmpty.next(false);

    this.$isErrorsLoading.next(false);
    this.$isErrorsError.next(false);
    this.$isErrorsEmpty.next(false);

    this.$isSubbyLoading.next(false);
    this.$isSubbyError.next(false);
    this.$isSubbyEmpty.next(false);

    this.$isMaintenanceLoading.next(false);
    this.$isMaintenanceError.next(false);
    this.$isMaintenanceEmpty.next(false);

    this.$isPSMLoading.next(false);
    this.$isPSMError.next(false);
    this.$isPSMEmpty.next(false);

    this.$isPSMDetailsLoading.next(false);
    this.$isPSMDetailsError.next(false);

    this.$isNotificationsLoading.next(false);
    this.$isNotificationsError.next(false);
    this.$isNotificationsEmpty.next(false);

    this.$isNotificationDetailsLoading.next(false);
    this.$isNotificationDetailsError.next(false);

    this.$isSparePartsLoading.next(false);
    this.$isSparePartsError.next(false);
    this.$isSparePartsEmpty.next(false);

    this.$isVisitsLoading.next(false);
    this.$isVisitsError.next(false);
    this.$isVisitsEmpty.next(false);

    this.$isEscalationsLoading.next(false);
    this.$isEscalationsError.next(false);
    this.$isEscalationsEmpty.next(false);

    this.$isUpcomingServicesLoading.next(false);
    this.$isUpcomingServicesError.next(false);
    this.$isUpcomingServicesEmpty.next(false);

    this.$isUpcomingServiceDetailsLoading.next(false);
    this.$isUpcomingServiceDetailsError.next(false);
    this.$isUpcomingServiceDetailsEmpty.next(false);
  }

}